<template>
	<el-row class="tac" style="">

		<el-col :span="3" style="
        max-width: 5vw;
        min-width: 1vw;
        background: #323a56;
      ">

			<div  :style="{lineHeight:(systemHeight*0.08)+'px'}" style="" class="el-menu-vertical-demo2">
				<img :src="logoSrc" class="img-responsive" :style="{height:(systemHeight*0.08)+'px'}" alt="">

			</div>

			<el-scrollbar  :style="{height:(systemHeight+50)+'px'}" >


				<!-- <div style="height:80px"  v-for="menu in menus" :key="menu.id" :index="`/nav/${menu.path}`">
						<router-link :to="`/nav/${menu.path}`">
						 <img style="width: 40%;margin-bottom:1rem" :src="menu.img" alt="">
						 <div style="margin-top: -2rem;"><span>{{ menu.authName }}</span></div>
					 </router-link>
				 </div> -->

				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" router>
					<el-menu-item :index="`/nav/${menu.path}`"  v-for="menu in menus" :key="menu.id"  :style="{height:(systemHeight*0.11)+'px'}" style="border-radius: 20%;">
						<div>

							<div  :style="{lineHeight:(systemHeight*0.05)+'px'}" style="user-select: none;" @click="speakText(menu.authName)">
								<img :style="{height:(systemHeight*0.05)+'px'}" :src="menu.img" alt="">
								<br>
								<span :style="{fontSize:(systemHeight*0.03)+'px'}">
                                {{ menu.authName }}
                                </span>
							</div>
						</div>
					</el-menu-item>
				</el-menu>
			</el-scrollbar>

			<!-- <router-link to="/nav/system-set" style="
					position: absolute;
					left: 26px;
					bottom: 30px;
					font-size: 20px;
					color: #000;
			">
					<i class="el-icon-setting"></i>
			</router-link> -->
		</el-col>
		<el-main>

			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</el-main>
	</el-row>
	<!-- <div class="sliderbar">
	<div class="oLeft">
		<el-menu :default-active="$route.path" class="el-menu-vertical-demo" router style="height: 100%">
			<el-menu-item :index="`/nav/${menu.path}`" v-for="menu in menus" :key="menu.id">
				<template slot="title">
					<span>{{ menu.authName }}</span>
				</template>
			</el-menu-item>
		</el-menu>
	</div>
	<div class="oRight">
		<router-view />
	</div>
</div> -->
</template>
<script>
import { getColorConfig, getLogo} from "@/api/system-set";
import { getRules} from "@/api/apis";
import {
	speak
} from "../api/index";
export default {
	data() {
		return {
			logoSrc: "",
			systemHeight:0,
			systemWidth:0,
			// checkedColor: "#4ca75b", // 选中时的颜色,主体颜色
			menus: [
				// {
				//     authName: "收银",
				//     path: "cashier",
				//     img: "",
				//     index: "1",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "货品",
				//     path: "commodity",
				//     img: "",
				//     index: "2",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "订单",
				//     path: "order",
				//     img: "",
				//     index: "3",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "打印",
				//     path: "printd",
				//      img: "",
				//     index: "7",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "买家",
				//     path: "member/index",
				//     img: "",
				//     index: "4",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "交班",
				//     path: "shift",
				//     img: "",
				//     index: "5",
				//     icon: "el-icon-s-finance",
				// },
				// {
				//     authName: "报表",
				//     path: "report",
				//     img: "",
				//     index: "6",
				//     icon: "el-icon-s-finance",
				// },

				// {
				//     authName: "设置",
				//     path: "system-set",
				//     img: "",
				//     index: "6",
				//     icon: "el-icon-s-finance",
				// }
			],
		};
	},
	created() {
		this.getRule();
		this.getColorConfig();
		this.doGetLogo();
		this.getHeight();
	},
	watch: {
		checkedColor: function (val) {
			let hex = val.replace("#", "");
			// const r = parseInt(hex.substr(0, 2), 16);
			// const g = parseInt(hex.substr(2, 2), 16);
			// const b = parseInt(hex.substr(4, 2), 16);
			// let style = document.createElement("style");
			// style.innerHTML = "";
			// document.head.appendChild(style);
		},
	},
	methods: {
	speakText(text){
				speak(text)
	},

		getHeight() {
			this.systemHeight=  window.innerHeight - 70;
			this.systemWidth=  window.innerWidth;


		},
		async doGetLogo() {
			const res = await getLogo();
			if (res.code === 200) {
				res.data.forEach((item) => {
					if (item.name == "desk_logo") {
						this.logoSrc = item.value;
					}
				});
			} else {
				this.$message.error(res.msg);
			}
		},
		// 获取颜色设置
		async getColorConfig() {
			const res = await getColorConfig();
			if (res.code === 200) {
				res.data.forEach((item) => {
					switch (item.name) {
						case "desk_color":
							// 收银台主体颜色
							this.checkedColor = item.value;
							break;
						default:
							break;
					}
				});
			} else {
				this.$message.error(res.msg);
			}
		},

		// 获取颜色设置
		getRule() {

			getRules([]).then((res) => {
				if (res.code == 200) {
					this.menus=res.data
				} else {

				}
			});
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
	},
};
</script>
<style scoped lang="less">

.el-menu-vertical-demo2{
	// line-height: 6rem;
	padding: 0 !important;
	text-align: center;
	margin: 0.5rem 0.2rem;
	font-size: 1.2rem;

}

.el-menu-vertical-demo{
	width: 5vw;
	border: none;
	background-color: #303a58;
	color: #ffffff;
}

/deep/.el-main {
	padding: 0;
	min-height: 100vh;
	// position: relative;
}

/deep/ .el-menu-item {
	height: 4.5rem;
	// line-height: 6rem;
	padding: 0 !important;
	text-align: center;
	margin: 0.5rem 0.2rem;
	font-size: 1.2rem;
	color: #ffffff;
}

/deep/.is-active {
	// border-radius: 20%;
	position: relative;
	font-weight: bold;
	// background-color: #53b460;
	color: #fbfcfb;
}

/deep/.is-active::after {
	content: "";
	width: 3px;
	height: 72px;
	// background: @desk-color;
	// background-color: #4ca75b;
	position: absolute;
	right: 0;
	top: 0;
}

/deep/.el-menu-item:hover,
.el-menu-item.is-active {
	background-color: #4ca75b;
}


.img-box {
	padding: 10px;
	// width: calc(100% - 20px);
	height: 50px;
	background: #323a56;
	display: flex;
	justify-content: center;
	align-items: center;
}
.img-box-header{
	padding: 0.4rem;
	background-color: #f3f5f6;
	// width: calc(100% - 20px);
	height: 3rem;
	line-height: 3rem;
	float: right;
	// background-color: red;
	// display: flex;


}

.img-responsive {
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue